import { SuperModel } from './super-model.model';
import { ERoles, EResources } from '@web/enums';
import { BITF_CONFIGS } from '@common/configs/common-bitf.configs';

export class User extends SuperModel {
  internalName: string;
  roles: ERoles[] = [];
  resources: EResources[] = [];
  displayName: string;
  email: string;
  userPrincipalName: string;
  cid: string;
  isAuthorized: boolean;
  canExceedCouponThreshold: boolean;

  constructor(data: Partial<User> = {}) {
    super(data);

    this.roles = this.mapRoles(data.roles);
    // this.resources = this.mapResources(data.resources);
    // this.setHomePage();
  }

  get serialised() {
    return {
      id: this.id,
      internalName: this.internalName,
      roles: this.roles,
      displayName: this.displayName,
      email: this.email,
      userPrincipalName: this.userPrincipalName,
      cid: this.cid,
      isAuthorized: this.isAuthorized,
      canExceedCouponThreshold: this.canExceedCouponThreshold,
    };
  }

  /* COUPON */
  get canGenerateCoupon() {
    return this.roles.includes(ERoles.EMPL);
  }
  get canBurnCoupon() {
    return this.roles.includes(ERoles.CASH);
  }
  get canManageJobs() {
    return this.roles.includes(ERoles.ADMIN);
  }
  get canGenerateUnlimitedCoupon() {
    return this.roles.includes(ERoles.WHLS);
  }
  get canAnonymizeData() {
    return this.roles.includes(ERoles.MNGR);
  }
  /**
   * VIEW PAGES
   */
  get canViewHome() {
    return this.resources.includes(EResources.HOME);
  }
  get canViewDocumentArchive() {
    return this.resources.includes(EResources.DOCUMENT_ARCHIVE);
  }
  get canViewSettings() {
    return this.resources.includes(EResources.SETTINGS);
  }
  get canViewCalendarSettings() {
    return this.resources.includes(EResources.SETTINGS_CALENDAR);
  }
  get canViewTagSettings() {
    return this.resources.includes(EResources.SETTINGS_TAG);
  }
  get canViewNewsSettings() {
    return this.resources.includes(EResources.SETTINGS_NEWS);
  }

  /**
   * FILE SYSTEM
   */
  get canEditDocument() {
    return true;
  }

  private mapRoles(roles: string[]): ERoles[] {
    return roles
      .map((element: string) => {
        element = element
          .toUpperCase()
          .replace(/ /g, '_')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
        return element as ERoles;
      })
      .filter((eRole: ERoles) => ERoles[eRole]);
  }

  private mapResources(resources: string[]): EResources[] {
    return resources
      .map((element: string) => {
        element = element.toUpperCase().replace(/-/g, '_');
        return element as EResources;
      })
      .filter((eRes: EResources) => EResources[eRes]);
  }

  private setHomePage() {
    if (this.resources.includes(EResources.HOME)) {
      BITF_CONFIGS.urls.homePageUrl = '';
    } else if (this.resources.includes(EResources.DOCUMENT_ARCHIVE)) {
      BITF_CONFIGS.urls.homePageUrl = 'documents';
    } else if (this.resources.includes(EResources.SETTINGS)) {
      BITF_CONFIGS.urls.homePageUrl = 'settings';
    } else {
      BITF_CONFIGS.urls.homePageUrl = 'unauthorized';
    }
  }
}
